export const MOISTURE_PERCENT_DEFAULT_UNIT = '%';
export const NOMINAL_WEIGHT_DEFAULT_UNIT = 'pounds/bushel';